import { isTag } from 'anodum';

const SPACE_KEY = ' ';

const insertSpaceOnButtonKeyDown = (e) => {
  const { srcElement } = e;
  const { ownerDocument: liveDocument } = srcElement;

  const isButton = isTag(srcElement, 'button');

  if (e.key !== SPACE_KEY || !isButton) {
    return;
  }

  liveDocument.execCommand('insertText', false, SPACE_KEY);
};

export default insertSpaceOnButtonKeyDown;
